import script from "./CardTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardTab.vue?vue&type=script&setup=true&lang=ts"

import "./CardTab.vue?vue&type=style&index=0&id=255a2aa7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-255a2aa7"]])

export default __exports__